module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAdCAMAAAA0LHRjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF3N3d0Obc2Ori6fLt6Ojpzd7W4e/nx9HK8/T0ytfQ+vz74ODh9vj30dHR////3u7pXD9ixQAAAIZJREFUeNrc1EkOgzAQRNGesMGY7vvfNtgWkSIG0SyQlb9/tSzQlNUVKBMi0pqFGrfGC2GHlZ0t+pYuxMlOEcEjjN0iPBIuYJRAyUm6FAiKPjG8IjJ5BVuPIvyJkBin2tDazuBczMtxsfWzVuYmgMUZsIjMULsp9qeXx5q0dmvgO9117SPAAGhUSlLhn7CAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/KS.png
// module id = iCJr
// module chunks = 1